import { NavigateToV1 } from '@/domain/mitarbeiter/pages/rotationsplan/NavigateToV1';
import { useProfile } from '@/hooks';
import { ReactNode } from 'react';

export function WithRotationsplanBenutzerrecht({
  children,
}: {
  children: ReactNode;
}) {
  const {
    manager: {
      rechte: {
        mitarbeiter: { rotationsplan: hasRotationsplanRecht },
      },
    },
  } = useProfile();

  if (!hasRotationsplanRecht) {
    return <NavigateToV1 />;
  }

  return children;
}
